/**
 * this module contains components, services and funtions that related to tempi
 * - tempi sdk
 * - build page by tempi sdk
 * - create customer tempi-sdk component
 */
export * from './page';
export * from './getServerSideProps';
export * from './desktop';
export * from './mobile';
export * from './types';
